<template>
  <div id="app">
    <router-link to="/"><img class="logo" src="/static/logo.png"></router-link>
    <div class="main-separator thin"></div>
    <b-navbar id="mainNav" toggleable="lg" v-bind:sticky="true">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-collapse is-nav id="nav_collapse" v-model="showCollapse">
        <b-navbar-nav justified>
          <b-nav-item v-on:click="collapseNav()"><router-link to="/portfolio/weddings">Weddings</router-link></b-nav-item>
          <b-nav-item v-on:click="collapseNav()"><router-link to="/portfolio/couples">Couples</router-link></b-nav-item>
          <b-nav-item v-on:click="collapseNav()"><router-link to="/portfolio/families">Families</router-link></b-nav-item>
          <b-nav-item v-on:click="collapseNav()"><router-link to="/investment">Investment</router-link></b-nav-item>
          <b-nav-item v-on:click="collapseNav()"><router-link to="/about">Meet Alyson</router-link></b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div class="main-separator thin"></div>
    <router-view></router-view>
    <b-container id="mainFooter">
    <div class="main-separator"></div>
      <b-row>
        <b-col>
          <div>Follow Along</div>
          <a href="http://www.facebook.com/pages/Alyson-Sivek-Photography/458803894155150?fref=ts">
            <icon name="brands/facebook" scale="2"></icon>
          </a>
        </b-col>
        <b-col>
          <div>Get In Touch</div>
          <a href="mailto:photographer@alysonsivek.com">photographer@alysonsivek.com</a>
        </b-col>
      </b-row>
      <b-row class="bottom">
        <b-col>Copyright 2013-2019 Alyson Sivek. All Rights Reserved.</b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      showCollapse: false
    }
  },
  methods: {
    collapseNav () {
      if (document.getElementById('nav_collapse').className.indexOf('show') > -1) {
        this.showCollapse = false
      }
    }
  }
}
</script>

<style>

body.slideshow {
  overflow-y: hidden;
}

#app {
  font-family: "Raleway",Helvetica,Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

#app .logo {
  max-width: 100%;
}

#mainNav {
  margin: 0 auto;
  max-width: 1000px;
  text-transform: uppercase;
  padding: 0;
  text-align: center;
}

#mainNav .navbar-toggler {
  width: 100%;
  background: white;
  font-size: 3vh;
}

#mainNav a {
  color: black;
}

#mainNav a:hover {
  color: #999;
}

#mainNav .navbar-nav {
  width: 100%;
  background: white;
  padding: .5rem 1rem;
}

@media (max-width: 992px) {
  #mainNav .navbar-nav {
    font-size: 3vh;
  }
}

#mainFooter {
  margin: 3em auto;
}

#app .photo-block {
  position: relative;
  overflow: hidden;
  text-align: center;
  background-size: cover;
  background-position: center;
  padding: 0;
}

#app .photo-block > div {
  padding-top: 100%;
}

.main-separator {
  margin: 40px 0;
  height: 1px;
  /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#ffffff+0,dbdbdb+50,ffffff+100&0+0,1+50,0+100 */
  background: -moz-linear-gradient(left, rgba(255,255,255,0) 0%, rgba(219,219,219,1) 50%, rgba(255,255,255,0) 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(left, rgba(255,255,255,0) 0%,rgba(219,219,219,1) 50%,rgba(255,255,255,0) 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(219,219,219,1) 50%,rgba(255,255,255,0) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#00ffffff',GradientType=1 ); /* IE6-9 */
  text-align: center;
}

.main-separator label {
  position: relative;
  top: -12px;
  background: white;
  font-size: 12px;
  padding: 0 0.3em;
  background-color: #dcdcdc;
  color: white;
}

.main-separator.thin {
  margin: 0;
}


.bottom {
  margin-top: 5em;
}
</style>



// WEBPACK FOOTER //
// src/App.vue